import { useCallback, useState } from "react";
import SystemError from "@components/SystemError";

export default function SystemErrorNotifier({ children }) {
  const [doShowError, setDoShowError] = useState(false);
  const showError = useCallback(() => setDoShowError(true), []);

  return (
    <>
      {doShowError ? <SystemError onHide={() => setDoShowError(false)} /> : null}
      {children(showError)}
    </>
  );
}
